import { useRouter } from 'next/router';

import { STALE_TIME } from '@framework/constants/query';

import useActiveRoom from '@hooks/rooms/useActiveRoom';
import useMember from '@hooks/useMember';

type UseLoggedMemberProps = {
    noRedirect?: boolean;
    enabled?: boolean;
};

const useLoggedMember = (props?: UseLoggedMemberProps) => {
    const router = useRouter();
    const activeRoom = useActiveRoom(props?.enabled);
    const organisationSlug = router?.query?.organisation as string;

    return useMember(
        {
            id: activeRoom?.memberUuid,
            organisationId: organisationSlug,
            ...props
        },
        {
            staleTime: STALE_TIME
        }
    );
};

export default useLoggedMember;
